import { CommonModule } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { RouterUtil } from '@seahorse/common';
import { SeahorseThemeComponent } from '@seahorse/layout';
import { AppShellComponent } from '@seahorse/shell';
import { LoadingIndicatorComponent } from '@seahorse/ui';
import { navigation } from '../sidebar/sidebar.config';

@Component({
  selector: 'su-app-theme',
  templateUrl: './super-user-app-theme.component.html',
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    LoadingIndicatorComponent,
    AppShellComponent,
  ],
})
export class SuperUserAppThemeComponent
  extends SeahorseThemeComponent
  implements OnInit, OnDestroy
{
  protected readonly navigation = navigation;
  protected readonly routerUtil = inject(RouterUtil);

  // The super-user login flow never adds to the stored accounts list (see
  // IdentityServiceBase.saveAccountInfo, only called from the customer
  // app's user-data.service.ts) -- reported in the implementation summary.
  // No profile route exists today either (the `users` routes are commented
  // out in super-user-routing.module.ts), so `profileRoute` is left unset
  // on purpose: sh-account-panel hides "My profile" in that case.
}
